import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';

interface Props {
  children: string;
}

// Markdown rendering used by issue bodies and comments. rehype-sanitize blocks
// all raw HTML; remark-gfm adds tables/strikethrough/task-lists/autolinks.
export function MarkdownBody({ children }: Props) {
  return (
    <div className="prose prose-sm max-w-none dark:prose-invert">
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
